import { render } from "./description_modal.vue?vue&type=template&id=4d6193f2"
import script from "./description_modal.vue?vue&type=script&lang=js"
export * from "./description_modal.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/description_modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d6193f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d6193f2', __exports__)) {
    api.reload('4d6193f2', __exports__)
  }
  
  module.hot.accept("./description_modal.vue?vue&type=template&id=4d6193f2", () => {
    api.rerender('4d6193f2', render)
  })

}


export default __exports__